import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API"; // Adjust the API instance import as per your setup
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const EditTaxes = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [tax, setTax] = useState([]);
  const token = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("businessPartnerId");
  const location = useLocation();
  const { data } = location.state || {};

  const fetchTax = async () => {
    try {
      const response = await axiosInstance.get(`/tax/edit/${data.taxes_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const fetchedData = response.data.data;
      const formatedData = {
        tax_name: fetchedData.tax_name,
        tax_percent: fetchedData.tax_percent,
        outside: fetchedData.outside,
        business_partner_id: fetchedData.business_partner_id,
        status: fetchedData.status === 1 ? true : false,
      };
      setFormData(formatedData);
      setTax(fetchedData);
      console.log(formData, "HSNCODE DATA");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTax();
  }, []);

  useEffect(() => {
    console.log(formData, "formDataaaa");
  });

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    // CustomerInputs.forEach((field) => {
    //   if (field.validation && field.validation.required) {
    //     if (!formData[field.name]) {
    //       errors[field.name] = "This field is required";
    //       isValid = false;
    //     }
    //   }
    // });

    CustomerInputs.forEach((field) => {
      if (field.validation?.required) {
        const value = formData[field.name];

        if (value === undefined || value === null || value === "") {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(value)
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);
        const payload = {
          tax_name: formData.tax_name,
          tax_percent: formData.tax_percent,
          outside: formData.outside,
          status: formData.status === true ? 1 : 0,
        };

        const response = await axiosInstance.patch(
          `/tax/update/${data.taxes_id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.status === 200) {
          await Swal.fire({
            title: "Success",
            text: "Taxes updated successfully.",
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          navigate(ROUTES_NAVIGATION.TAXESLIST);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred while processing your request.";
        await Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const CustomerInputs = [
    {
      name: "tax_name",
      label: "Tax Name",
      type: "text",
      required: true,
      gridClass: "col-lg-3",
      validation: validations.taxName({ required: true }),
      disabled: true,
    },
    {
      name: "tax_percent",
      label: "Tax percentage",
      type: "number",
      isDecimal: true,
      required: true,
      gridClass: "col-lg-3",
      validation: validations.percentage({ required: true }),
    },
    {
      name: "outside",
      label: "Government Tax?",
      type: "dropdown",
      required: true,
      options: [
        { label: "YES", value: 1 },
        { label: "NO", value: 0 },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      required: true,
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Edit Tax</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Tax Details
              </span>
              <DynamicForm
                validateOnMount
                formConfig={CustomerInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(CustomerInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  CustomerInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => handleFormSubmit(formData)}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditTaxes;
